import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Bold%20fashion%20product%20flatlay%20with%20designer%20sneakers%20streetwear%20hoodies%20caps%20and%20bags%20on%20pure%20white%20surface%2C%20striking%20studio%20lighting%2C%20high%20contrast%20editorial%20product%20photography%2C%20modern%20fashion%20retail%20aesthetic%2C%20clean%20composition%2C%20colorful%20items&width=1600&height=1000&seq=kakobuy-cta-bg-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet products"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 py-20">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-black text-background-50 tracking-wider">
            {t("cta.title")}
          </h2>
          <p className="mt-6 text-base md:text-lg text-background-50/85 leading-relaxed">
            {t("cta.subtitle_line1")}
            <br />
            {t("cta.subtitle_line2")}
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-8 py-4 bg-foreground-900 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer group"
            >
              <span className="w-8 h-8 rounded-full bg-accent-500 flex items-center justify-center">
                <i className="ri-shopping-bag-line text-sm text-background-50"></i>
              </span>
              <span>{t("cta.buynow")}</span>
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm text-background-50 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200"></i>
              </span>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-4 border-2 border-background-50/30 text-background-50 rounded-full text-sm font-medium hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <span>{t("cta.spreadsheet")}</span>
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}